let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4qT53")).then(() => parcelRequire('5eYjE'));